<template>
  <div class="worksComment-section" v-loading="loading">
    <div class="Comment-mark">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>作品中心</el-breadcrumb-item>
        <el-breadcrumb-item>作品详情</el-breadcrumb-item>
        <el-breadcrumb-item>评论</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="worksComment-content">
      <div class="Comment-title">【{{ worksData.poetry_name }}】</div>
      <div class="Comment-author">
        <span>学生姓名：{{ worksData.author }}</span>
        <span>指导老师：{{ worksData.teacher_name }}</span>
      </div>
      <div class="Comment-information">文明上网理性发言</div>
      <div class="Comment-enter">
        <el-avatar
          :src="
            'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
          "
          :size="60"
        ></el-avatar>
        <el-input
          type="textarea"
          resize="none"
          :rows="5"
          placeholder="请输入内容"
          v-model="textarea"
        ></el-input>
      </div>
      <div class="Comment-submit">
        <el-button @click="handleCommentCreate">发表评论</el-button>
      </div>
      <div class="comment-list-wrap">
        <div class="all-comment-data">
          全部评论
          <span>{{ total }} 条</span>
        </div>
        <div class="all-comment-conten">
          <div class="all-comment-conten_list">
            <div
              class="all-comment-conten_list-item"
              v-for="(item, index) in commentList"
              :key="item.comment_id"
            >
              <el-avatar
                class="all-comment-conten_list-item_image"
                :src="
                  'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
                "
                :size="60"
              ></el-avatar>
              <div class="all-comment-conten_list-item_content">
                <div class="header">
                  <div class="header_name_date">
                    <p class="header_mame">
                      {{ (item.comment_teacher || {}).name }}
                    </p>
                    <p class="header_date">{{ item.created_at }}</p>
                  </div>
                  <el-button
                    @click="report(item)"
                    type="text"
                    class="header_report"
                    v-if="item.is_auth_tipped === false"
                    >举报</el-button
                  >
                  <p
                    type="text"
                    class="header_report"
                    style="font-weight: 700;"
                    v-else
                  >
                    已举报
                  </p>
                </div>
                <div class="body">
                  <div class="body_text">
                    <p class="body_text-title">{{ item.comment_msg }}</p>
                  </div>
                  <div class="body_handle">
                    <span v-if="item.is_auth_praised === false">
                      <img
                        src="@/image/workCenter/p5.png"
                        @click="praise(item)"
                      />
                    </span>
                    <span v-else>
                      <img src="@/image/workCenter/p7.png" />
                    </span>
                    <span @click="inputShow(index, item.id)">
                      <img src="@/image/comment.png" />
                    </span>
                  </div>
                  <div class="body_text-input" v-if="item.show">
                    <el-input
                      size="mini"
                      placeholder="请输入你评论"
                      v-model="replyContent"
                    ></el-input>
                    <el-button type="mini" @click="answer(item.id)"
                      >回复</el-button
                    >
                  </div>
                  <div
                    class="body_text-reply"
                    v-for="data in item.replies"
                    :key="data.id"
                  >
                    <el-avatar
                      class="all-comment-conten_list-item_image"
                      :src="
                        'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
                      "
                      :size="30"
                    ></el-avatar>
                    <div class="reply-header">
                      <div class="reply-header-name_date">
                        <p class="reply-header-name">
                          {{ (data.reply_teacher || {}).name }}
                        </p>
                        <p class="reply-header_date">{{ data.created_at }}</p>
                      </div>
                      <p class="reply-content">{{ data.reply_msg }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        :total="total"
        @current-change="handleChangePage"
        :hide-on-single-page="true"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import workService from "@/global/service/work";
export default {
  data() {
    return {
      replyContent: "",
      show: {
        index: null,
        id: null
      },
      commentList: [],
      textarea: "",
      worksData: {},
      workId: null,
      pageSize: 10,
      currentPage: 1,
      total: 0,
      loading: false
    };
  },
  created() {
    this.workId = this.$route.params.id;
    this.getList();
    this.getData();
  },
  methods: {
    answer(id) {
      let params = {
        reply_msg: this.replyContent
      };
      workService.commentReply(this.workId, id, params).then(() => {
        this.replyContent = "";
        this.getList();
      });
    },
    praise(item) {
      workService.commentPraise(this.workId, item.id).then(() => {
        this.$message.success("点赞成功");
        item.is_auth_praised = true;
      });
    },
    report(item) {
      this.$confirm("确认要举报此条评论吗？").then(() => {
        workService.commentTip(this.workId, item.id).then(() => {
          this.$message.success("举报成功");
          item.is_auth_tipped = true;
        });
      });
    },
    inputShow(index) {
      this.commentList[index].show = !this.commentList[index].show;
    },
    handleCommentCreate() {
      let params = {
        comment_msg: this.textarea
      };
      workService.commentCreate(this.workId, params).then(() => {
        this.textarea = "";
        this.$message.success("发表成功");
        this.getList();
      });
    },
    getList() {
      this.loading = true;
      const params = {
        page: this.currentPage,
        page_size: this.pageSize
      };
      workService
        .commentList(this.workId, params)
        .then(res => {
          res.list.forEach(data => {
            data.show = false;
          });
          this.commentList = res.list;
          this.currentPage = res.pagination.current_page;
          this.total = res.pagination.total;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getData() {
      workService.studentWorkDetail(this.workId).then(res => {
        this.worksData = res;
      });
    },
    getComment() {},
    handleChangePage(current) {
      this.currentPage = current;
      this.getList();
    }
  }
};
</script>
<style lang="less" scoped>
.worksComment-section {
  width: 70%;
  margin: 0 auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  color: #2c3e50;
  .Comment-mark {
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 10px;
    /deep/.el-breadcrumb__item {
      font-size: 12px;
    }
  }
  .worksComment-content {
    margin-top: 20px;
    background: #ffffff;
    text-align: left;
    padding: 0 20px;
    /deep/.el-pagination {
      text-align: center;
    }
    .Comment-title {
      font-size: 24px;
      color: #2c3e50;
      text-align: left;
      padding-top: 30px;
    }
    .Comment-author {
      text-align: left;
      padding-top: 10px;
      span {
        padding-right: 20px;
      }
    }
    .Comment-information {
      font-size: 12px;
      margin-top: 10px;
    }
    .Comment-enter {
      padding-top: 30px;
      display: flex;
      .el-avatar {
        margin-right: 20px;
      }
    }
    .Comment-submit {
      padding: 20px;
      text-align: right;
      .el-button {
        width: 80px;
        height: 32px;
        padding: 0;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .comment-list-wrap {
      margin-top: 10px;
      border-top: 1px solid #dedede;
      .all-comment-data {
        padding: 20px 10px;
      }
      .all-comment-conten {
        padding: 10px;
      }
    }
  }
}
.all-comment-conten_list {
  width: 100%;
  .all-comment-conten_list-item {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    border-bottom: 1px solid #dedede;
    .all-comment-conten_list-item_image {
      width: 60px;
      height: 60px;
      vertical-align: top;
    }
    .all-comment-conten_list-item_content {
      margin-left: 20px;
      flex: 1;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        line-height: 18px;
        padding: 0 8px;
        .header_name_date {
          display: flex;
          font-size: 12px;
          color: #2c3e50;
          .header_mame {
            margin-right: 30px;
          }
        }
        .header_report {
          font-size: 12px;
          color: #2c3e50;
        }
      }
      .body {
        margin-top: 10px;
        .body_text-title {
          min-height: 30px;
          font-size: 13px;
          color: #999;
        }
        .body_handle {
          display: flex;
          flex-direction: row-reverse;
          align-items: center;
          margin: 10px 0;
          span {
            margin: 0 5px;
            font-size: 12px;
            color: #dedede;
            img {
              width: 15px;
              height: 15px;
            }
          }
        }
        .body_text-input {
          display: flex;
          margin-bottom: 10px;
        }
        .body_text-reply {
          width: 800px;
          display: flex;
          background-color: #f5f5f5;
          margin-bottom: 5px;
          border-radius: 3px;
          padding: 10px;
          .all-comment-conten_list-item_image {
            width: 60px;
            height: 60px;
            vertical-align: top;
            margin-right: 10px;
          }
          .reply-header-name_date {
            display: flex;
            flex: 1;
            align-items: center;
            margin-bottom: 10px;
            font-size: 12px;
            .reply-header-name {
              margin-right: 30px;
              min-width: 30px;
            }
          }
          .reply-content {
            min-height: 30px;
            font-size: 12px;
            color: #2c3e50;
          }
        }
      }
    }
  }
}
</style>
